export default [
    {
        // UserProfile will be rendered inside User's <router-view>
        // when /user/:id/profile is matched
        path: '/categories',
        name: 'categories',
        component: () => import('../views/Category.vue'),
        meta: {
            requiresAuth: true,
            authorize: ['ROLE_ADMIN'],
            layout: 'default',
            breadcrumb: 'catégories',
            description: 'Gestion des catégories de produits'
        }
    }
]
